import { Trash2 } from "lucide-react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useImmer } from "use-immer";

import { IgIconButton, IgTextField } from "@intelligems/ig-theme";
import {
  ClickEventCustomEvent,
  ElementViewedCustomEvent,
} from "@intelligems/ig-types";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { AddAnotherButton } from "@src/components/Utils/AddAnotherButton";
import {
  selectedCurrentCustomEvent,
  setCustomEventSelectors,
} from "@src/store/slices/customEvents";

interface CustomEventElementsProps {
  isArchived: boolean;
}

export const CustomEventElements = ({
  isArchived,
}: CustomEventElementsProps) => {
  const dispatch = useDispatch();
  const currentEvent = useSelector(selectedCurrentCustomEvent);
  const theme = useTheme();
  const [selectors, setSelectors] = useImmer<string[]>(
    currentEvent?.type === "clickEvent" ||
      (currentEvent?.type === "elementViewed" && currentEvent?.id)
      ? (currentEvent as ElementViewedCustomEvent | ClickEventCustomEvent)
          .settings.selectors
      : [""]
  );

  const handleChangeSelector = (index: number, value: string) => {
    setSelectors((draft) => {
      draft[index] = value;
    });
  };

  const handleAddSelector = () => {
    setSelectors((draft) => {
      draft.push("");
    });
  };

  const handleRemoveSelector = (index: number) => {
    setSelectors((draft) => {
      draft.splice(index, 1);
    });
  };

  useEffect(() => {
    dispatch(setCustomEventSelectors({ selectors }));
  }, [selectors]);

  return (
    <Grid container marginTop={"10px"} width={"100%"}>
      {selectors.map((selector, index) => {
        return (
          <Grid
            key={index}
            container
            wrap={"nowrap"}
            alignItems={"center"}
            marginBottom={"10px"}
            width={"100%"}
          >
            <IgTextField
              fullWidth
              placeholder={"Enter a DOM selector (ex: #MyButton)"}
              disabled={isArchived}
              sx={{
                marginRight: "10px",
              }}
              value={selector}
              onChange={(e) => handleChangeSelector(index, e.target.value)}
            />
            <IgIconButton onClick={() => handleRemoveSelector(index)}>
              <Trash2
                size={18}
                className="trash-can"
                color={theme.igIconColors.error}
              />
            </IgIconButton>
          </Grid>
        );
      })}
      {!isArchived && (
        <AddAnotherButton
          itemLabel={"Track More Elements"}
          onAddClick={handleAddSelector}
        />
      )}
    </Grid>
  );
};
